exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-expansion-panel-body {\n  overflow: auto;\n  height: 500px;\n  padding: 0;\n  margin: 0 24px 16px;\n}\n.full-width {\n  width: 100%;\n}\n.mat-expansion-panel-body {\n  min-height: 500px;\n}\n.searchWrapper {\n  margin-bottom: 100px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/hq/cards/modify-card/add-second-product/add-second-product.component.css
// module id = ../../../../../src/app/hq/cards/modify-card/add-second-product/add-second-product.component.css
// module chunks = main